<template>
  <div class="container-fluid ">
    <div class="about" style="padding-top: 15px;">
        <h2>打線シミュレーター ver1.11</h2>
            実際の野球選手の成績と進塁確率データを元に打線の得点力をシミュレーションするwebアプリです。<br>
            使い方の解説は<a href="https://pennantspirits.blogspot.com/2020/03/v100.html">こちら。</a><br>
            このアプリを使用したことによって生じたすべての障害・損害・不具合等に関しては、一切の責任を負いません。<br>
    </div>
  </div>
</template>
<script>

export default {
  name: 'about'
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue